<div class="index-shell">
    <app-header [breadcrumbs]="['Inbox']" mainHeading="Inbox" [links]="['/messages']">
        <div headingButton>
            <button class="add-button" cll-filled-button colour="secondary" (click)="createNewMessage()">
                <cll-icon type="outlined">add</cll-icon>
                New message
            </button>
        </div>
    </app-header>

    @if (threads.result$ | async; as result) {
        @if (result.isLoading) {
            <cll-spinner />
        }

        @if (result.error; as error) {
            <app-error-panel [error]="error" />
        }
    }

    @if (changeParticipantRequest.error(); as error) {
        <app-error-panel [error]="error" />
    }

    <div class="messages-holder">
        <div class="inbox-container">
            <div class="messages-container">
                <div class="inbox-search-container">
                    <cll-form-field label="Type a keyword...">
                        <cll-icon cllPrefix>search-bar</cll-icon>
                        <input cllFormInput type="text" [value]="keyword()" (input)="keyword.set($any($event.target).value)">
                    </cll-form-field>
                </div>
                <div class="inbox-sort-container">
                    <div>
                        <input type="checkbox" class="inbox-check-box" (change)="onSelectAllChange($event)" [checked]="areAllSelected()"/>
                    </div>
                </div>
                <div class="messages-list">
                    @if (filteredThreads$ | async; as result) {
                        @for (thread of result; track thread.id) {
                            @if (userId$ | async; as userId) {
                                <app-thread-inbox-message       [thread]="thread"
                                [userId]="userId"
                                [selectedThreadId]="selectedThread()?.id ?? ''"
                                [selected]="selectedThreadIds.includes(thread.id)"
                                (threadClick)="onThreadClicked($event)"
                                (checkboxChanged)="onCheckboxChange($event)"
                                                          />
                            }
                        }
                    }
                    @if (!threads) {
                        <div class="no-messages-container">
                            <cll-icon [size]="48" type="outlined" class="no-mail-icon">folder_open</cll-icon>
                            <div class="no-message-text-container">
                                <span class="no-message-text">No messages, yet</span>
                                <span class="no-message-detail">Your inbox is empty. Messages will appear here when received</span>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <app-thread-messages
                (addRemoveParticipantEvent)="addRemoveParticipant($event)"
                (addReplyEvent)="addReply()"
            />
        </div>
    </div>
    <app-messages-actions
        [selectedThreadIds]="selectedThreadIds"
        (clearSelection)="clearSelectedThreads()"
        (refreshData)="threads.refresh()" />
</div>
